// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import CheckboxWithSearchFilterControlled from '../../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../../shared/components/facets/facet-footer/index';
import Facets from '../../state/facets';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../../shared/services/facets';

function handleDealerFilterInput(text) {

    this.actions.updateDealerAccountFacetInput(text);

}

function handleDealerAccountFacetItem(item, isSelected) {

    this.actions.updateDealerAccountFacetItem(item, isSelected);

}

function handleApplyFilters() {

    if (!isDealerFacetInvalid(this.facets.dealerAccountsFacet)) {

        this.actions.readDealerInvoices(false);

    }

}

function handleResetFilters() {

    this.actions.resetAllFacets(this.facets);

}

function toggleDealerAccountFacetItems() {

    this.actions.toggleDealerAccountFacetItems(this.facets.dealerAccountsFacet.allowedDealers);

}
class DealerInvoiceFacets extends Component {

    state = {
        dealerLocationExpanded: false
    };

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.dealerLocationExpanded;

    render() {

        return (
            <div className='dealer-invoice-facets'>
                <CheckboxWithSearchFilterControlled
                    canUseDefaultFormat={true}
                    initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                    isExpanded={this.state.dealerLocationExpanded}
                    list={addCollectionLabels(this.props.facets.dealerAccountsFacet.displayedDealers)}
                    minNumberOfItems={4}
                    onCheckboxListChange={this.props::handleDealerAccountFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    onInputChange={this.props::handleDealerFilterInput}
                    onToggleAll={this.props::toggleDealerAccountFacetItems}
                    searchInput={this.props.facets.dealerAccountsFacet.searchInput}
                    searchPlaceholder='DEALER_LOCATION_FILTER'
                    title='DEALER_LOCATIONS'
                    valueKey={'account'}
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={isDealerFacetInvalid(this.props.facets.dealerAccountsFacet)}
                        onApply={this.props::handleApplyFilters}
                        onReset={this.props::handleResetFilters}
                    /> : null}
            </div>
        );

    }

}

DealerInvoiceFacets.displayName = 'DealerInvoiceFacets';
DealerInvoiceFacets.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.instanceOf(Facets)
};

export default DealerInvoiceFacets;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/dealer-invoice-facets/dealer-invoice-facets-container.js